module.exports = __webpack_public_path__ + "d688a47a80782381624ccdf8c81d5513.svg";